import {SelectItem} from 'primeng/components/common/api';


export class DataTableFieldValidator {
  public type: string;
  public field: string;
  public check: string;
  public reverse: boolean;
}
export class DataTableField{
  public id: string;
  public label: string;
  public notSortable?: boolean;
  public filterType?: string;
  public decimals?: string;
  public comboOptions?: SelectItem[];
  public editable?: boolean;
  public filterable?: boolean;
  public validator?: DataTableFieldValidator;
}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/dataTable/dataTableField.interface.ts